


























import { computed, defineComponent } from '@nuxtjs/composition-api';

const YOUTUBE_BASE_URL = 'https://www.youtube.com';

export default defineComponent({
  name: 'VideoCard',
  props: {
    tag: {
      type: String,
      default: '',
    },
    mediaSrc: {
      type: String,
      required: true,
    },
    mediaAlt: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    author: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      default: 'Read More',
    },
    showLinkText: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isYoutube = computed(() => props.mediaSrc.startsWith(YOUTUBE_BASE_URL));

    function onYoutubeVideoClick(event: any) {
      event.preventDefault();
    }

    return {
      isYoutube,
      onYoutubeVideoClick,
    };
  },
});
